import clsx from "clsx";
import React, { JSX } from "react";

type Variant = "primary" | "secondary";

export const Button = ({
  variant = "primary",
  title,
  prefix,
  postfix,
  disabled = false,
  rounded = "md",
  className,
  onClick,
  style,
}: {
  variant: Variant;
  title?: string;
  prefix?: JSX.Element;
  postfix?: JSX.Element;
  rounded?: "none" | "sm" | "md" | "lg" | "xl" | "full";
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
}) => {
  const classes = clsx(
    {
      "text-md bg-colGray p-2 font-medium text-quaternary focus:outline-none":
        variant === "primary",
      "text-md bg-colPrimary p-2 font-medium text-white focus:outline-none":
        variant === "secondary",
      "rounded-none": rounded === "none",
      "rounded-sm": rounded === "sm",
      "rounded-md": rounded === "md",
      "rounded-lg": rounded === "lg",
      "rounded-xl": rounded === "xl",
      "rounded-full": rounded === "full",
      "flex items-center justify-center": prefix || postfix,
    },
    className
  );

  return (
    <button
      type="submit"
      className={classes}
      onClick={onClick}
      style={style}
      disabled={disabled}
    >
      {prefix && <span className="mr-2">{prefix}</span>}
      {title}
      {postfix && <span className="ml-2">{postfix}</span>}
    </button>
  );
};
